export const SEG_LOCAL = 'local';
export const SEG_NETWORK = 'network';
export const SEG_INTERNET = 'internet';
